import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import { Button } from '@mui/material';
import { useState } from 'react';
import { Contact } from '../../../../sic-lib/types/Contact';
import AutomationDialog from '../../Automation/AutomationDialog';

interface Props {
    contact: Contact;
    hasAiFeature: boolean;
}

export default function Automation({ contact, hasAiFeature }: Props) {
    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

    const handleClick = () => {
        setIsDialogOpen(true);
    };
    const handleClose = () => {
        setIsDialogOpen(false);
    };

    return (
        <>
            <Button
                onClick={handleClick}
                variant="outlined"
                color="primary"
                startIcon={<ScheduleSendIcon />}
            >
                Automation
            </Button>
            <AutomationDialog
                isDialogOpen={isDialogOpen}
                onCloseHandler={handleClose}
                contact={contact}
                hasAiFeature={hasAiFeature}
            />
        </>
    );
}
